// extracted by mini-css-extract-plugin
export default {"uploadVideo":"upload-video_uploadVideo__Cv7Vh","table":"upload-video_table__PXgWV"};